import { useCallback } from 'react';
import { Platform } from 'react-native';
import { type DeliveryOrderDetail } from '@sg/graphql-schema';

import { type OrderingContext } from '@order/features/ordering';

import { useGlobalAppState } from '../../../../context/GlobalAppState';
import { type PartialLineItem } from '../../../../graphql';

export const useOnPostOrder = () => {
  const { postPurchaseModalMachineRef } = useGlobalAppState();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const showPostPurchaseModal = useCallback(
    (context: OrderingContext<PartialLineItem, DeliveryOrderDetail>) => {
      const { orderId, hasEarnedLoyaltyPoints } = context;

      if (!orderId || !hasEarnedLoyaltyPoints) return;

      // NOTE: We use a short delay on iOS because of a known issue during
      //       interactions between two modals.
      setTimeout(
        () => {
          postPurchaseModalMachineRef.send({ type: 'show', orderId });
        },
        Platform.select({ ios: 750, default: 0 }),
      );
    },
    [postPurchaseModalMachineRef],
  );

  // ─────────────────────────────────────────────────────────────────────

  return { onPostOrder: showPostPurchaseModal };
};
